import { Box, Typography } from '@mui/material';

import { ENTITY_PREFIX } from '../../../../constants';
import { formatEntityId } from '../../../../helpers';
import {
  HEADER_BAY_BADGE_SX,
  HEADER_BAY_WRAPPER_SX,
  HEADER_FIELD_LABEL_SX,
  HEADER_FIELD_ROW_SX,
  HEADER_FIELD_VALUE_SX,
  HEADER_METADATA_SX,
} from '../styles';

import type { HeaderMetadataProps } from '../types';

export default function HeaderMetadata({
  author,
  bay,
  child,
  created,
  headerTreatmentPlanId,
  status,
  t,
}: HeaderMetadataProps) {
  return (
    <Box sx={HEADER_METADATA_SX}>
      <Box sx={HEADER_FIELD_ROW_SX}>
        <Typography sx={HEADER_FIELD_LABEL_SX}>{t('author')}</Typography>
        <Typography sx={HEADER_FIELD_VALUE_SX}>{author}</Typography>
      </Box>

      {status ? (
        <Box sx={HEADER_FIELD_ROW_SX}>
          <Typography sx={HEADER_FIELD_LABEL_SX}>{t('status')}</Typography>
          <Typography sx={HEADER_FIELD_VALUE_SX}>
            {status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()}
          </Typography>
        </Box>
      ) : null}
      {headerTreatmentPlanId ? (
        <Box sx={HEADER_FIELD_ROW_SX}>
          <Typography sx={HEADER_FIELD_LABEL_SX}>{t('tp')}</Typography>
          <Typography sx={HEADER_FIELD_VALUE_SX}>
            {formatEntityId(headerTreatmentPlanId, ENTITY_PREFIX.TreatmentPlan)}
          </Typography>
        </Box>
      ) : null}
      {created ? (
        <Box sx={HEADER_FIELD_ROW_SX}>
          <Typography sx={HEADER_FIELD_LABEL_SX}>{t('created')}</Typography>
          <Typography sx={HEADER_FIELD_VALUE_SX}>{created}</Typography>
        </Box>
      ) : null}
      {child ? (
        <Box sx={HEADER_FIELD_ROW_SX}>
          <Typography sx={HEADER_FIELD_LABEL_SX}>{t('child')}</Typography>
          <Typography sx={HEADER_FIELD_VALUE_SX}>{child}</Typography>
        </Box>
      ) : null}
      {bay ? (
        <Box sx={HEADER_BAY_WRAPPER_SX}>
          <Typography sx={HEADER_BAY_BADGE_SX}>{bay}</Typography>
        </Box>
      ) : null}
    </Box>
  );
}
